import $ from "jquery";
import "jquery.scrollto";
import gsap from "gsap";
import BezierEasing from "bezier-easing";
import "../../../node_modules/gsap/TextPlugin.js";
import stage from "../components/stage";
import render from "../components/render";
import enableInlineVideo from "iphone-inline-video";
import slick from "slick-carousel";

class Homepage {
  constructor() {
    this.init();
  }

  init() {
    this.renderQue = this.render.bind(this);
    this.resizeQue = this.resize.bind(this);

    this.addEvents();
    console.log("homepage.js loaded");
  }

  startPage() {
    this.body = $("body");
    this.animate = $(".animate");
    this.calculator = $(".calculator");
    this.gradient = $(".gradient");
    this.pos = 0;
    this.parallaxvideo = $("#video");
    this.video = $("#video")[0];
    this.parallax = $(".section");

    if (this.video) {
      enableInlineVideo(this.video);
    }

    $("#clients").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 2000,
    });

    $(".connect__item").each((index, el) => {
      $(el).prepend('<div class="ripple"></div>');
    });
    this.addAnimations();
    stage.on("stage:scroll", this.renderQue);
    stage.on("stage:resize", this.resizeQue);
    this.resize();

    var path = window.location.pathname;
    if (path.indexOf("add-ons") !== -1) {
      var section = $('[data-section="integrations"]');
      $.scrollTo(
        { top: section.data("position"), left: 0, interrupt: true },
        50
      );
    }
  }

  addEvents() {
    this.startPage();
  }

  removeEvents() {
    $.each(this.Animation, (index, el) => {
      TweenMax.killAll();
      index = null;
    });
    this.Animation = null;
    stage.removeListener("stage:scroll", this.renderQue);
    stage.removeListener("stage:resize", this.resizeQue);
  }

  addAnimations() {
    this.Animation = {};

    var cloneipad = $(".ipad__slide").first().clone();
    $(".ipad").append(cloneipad.addClass("cloned"));

    const tipad = new TimelineMax({ paused: true });
    tipad.staggerFrom(
      ".ipad__slide",
      0.7,
      {
        x: "100%",
        autoAlpha: 1,
        className: "+=is-from",
        ease: new Ease(BezierEasing(0.48, 0, 0.12, 1)),
        force3D: true,
      },
      4
    );
    tipad.staggerTo(
      ".ipad__slide:not(.cloned)",
      0.9,
      { scale: 0.75, autoAlpha: 0, className: "+=is-active", force3D: true },
      4,
      4
    );

    this.Animation.ipad = tipad;

    const tc = new TimelineMax({ paused: true, repeat: -1 });
    tc.fromTo(
      ".invoice__button--job",
      0.5,
      { x: 200 },
      { x: "-50%", ease: Power2.easeOut },
      0
    );
    tc.to(
      ".invoice__button--job",
      1,
      { css: { backgroundColor: "#006899" } },
      1
    );
    tc.to(".invoice__button--job", 0.3, { scale: 0.9 }, 1);
    tc.to(".invoice__button--job", 1, { scale: 0, ease: Power2.easeOut }, 1.5);
    tc.fromTo(
      ".invoice",
      0.5,
      { y: 200, scale: 0 },
      { y: 0, scale: 1, ease: Back.easeOut },
      1.7
    );
    tc.fromTo(
      ".invoice__button--pay",
      0.5,
      { scale: 0 },
      { scale: 1, ease: Back.easeOut },
      2.3
    );
    tc.to(
      ".invoice__button--pay",
      0.5,
      {
        css: {
          backgroundColor: "#50E3C2",
          borderRadius: 0,
          width: "100%",
          left: 0,
          marginTop: -87,
        },
        force3D: true,
      },
      4
    );
    tc.set(".invoice__button--pay", { autoAlpha: 0 }, 5);
    tc.to(
      ".invoice__button--pay span",
      0.5,
      { autoAlpha: 0, force3D: true },
      4
    );
    tc.fromTo(
      ".invoice__paid",
      0.8,
      { scaleY: 0, force3D: true },
      { scaleY: 1, force3D: true },
      4.4
    );
    tc.fromTo(
      ".paid",
      0.8,
      { autoAlpha: 0, y: "-20", force3D: true },
      { autoAlpha: 1, y: 0, force3D: true, ease: Power4.easeOut },
      5.1
    );
    tc.fromTo(
      ".paid__done",
      0.8,
      { autoAlpha: 0, force3D: true },
      { autoAlpha: 1, force3D: true },
      5.3
    );
    tc.fromTo(
      ".paid__done",
      0.8,
      { scale: 0, force3D: true },
      { scale: 1, force3D: true, ease: Back.easeOut },
      5.3
    );
    tc.to(
      ".paid",
      0.8,
      { autoAlpha: 0, y: "-20", force3D: true, ease: Power4.easeOut },
      7.1
    );
    tc.to(".paid__done", 0.8, { autoAlpha: 0, force3D: true }, 7.1);
    tc.to(".invoice", 1, { y: "-50", scaleY: 0, ease: Power4.easeOut }, 8);

    this.Animation.calculator = tc;
    this.tsharevar = 90;
    this.tshare = new TimelineMax({ paused: true, repeat: -1 });
    this.tshare.fromTo(
      ".stair1",
      0.5,
      { x: -this.tsharevar, y: -this.tsharevar, scale: 0 },
      { x: -this.tsharevar, y: -this.tsharevar, scale: 1, ease: Back.easeOut },
      0
    );
    this.tshare.fromTo(
      ".stair2",
      0.5,
      { x: 0, y: 0, scale: 0 },
      { x: 0, y: 0, scale: 1, ease: Back.easeOut },
      0.2
    );
    this.tshare.fromTo(
      ".stair3",
      0.5,
      { x: this.tsharevar, y: this.tsharevar, scale: 0 },
      { x: this.tsharevar, y: this.tsharevar, scale: 1, ease: Back.easeOut },
      0.4
    );
    this.tshare.to(".stair1", 0.5, { x: 0, y: 0, ease: Power2.easeOut }, 2.5);
    this.tshare.to(".stair3", 0.5, { x: 0, y: 0, ease: Power2.easeOut }, 2.5);
    this.tshare.to(".stair3", 2.5, { x: -1000, ease: Power2.easeOut }, 4.5);
    this.tshare.to(".stair2", 2.5, { x: -1000, ease: Power2.easeOut }, 4.6);
    this.tshare.to(".stair1", 2.5, { x: -1000, ease: Power2.easeOut }, 4.7);

    this.tshare.to(
      ".stair__icon.icon--email",
      1,
      { autoAlpha: 1, ease: Power2.easeOut },
      4.5
    );
    this.tshare.to(
      ".stair__icon.icon--email",
      1,
      { autoAlpha: 0, ease: Power2.easeOut },
      6
    );
    this.tshare.to(
      ".stair__icon.icon--done",
      1,
      { autoAlpha: 1, ease: Power2.easeOut },
      6
    );
    this.tshare.to(
      ".stair__icon.icon--done",
      1,
      { autoAlpha: 1, ease: Power2.easeOut },
      7.5
    );

    this.Animation.share = this.tshare;

    const ts = new TimelineMax({ paused: true, repeat: -1, repeatDelay: 1 });
    ts.staggerFrom(".status", 0.5, { scale: 0, ease: Back.easeOut }, 0.2, 0);
    ts.staggerTo(
      ".status",
      0.1,
      { css: { className: "+=status--confirmed" } },
      0.2,
      2
    );
    ts.staggerFromTo(
      ".statuses .status__button",
      0.3,
      {
        cycle: {
          text: ["Pending", "Pending", "Pending", "Pending", "Overdue"],
        },
      },
      {
        cycle: { text: ["Confirmed", "Set", "Accepted", "Confirmed", "Paid"] },
      },
      0.2,
      2
    );
    ts.staggerTo(".status", 0.5, { scale: 0, ease: Back.easeIn }, 0.3, 4);

    this.Animation.spreadsheets = ts;

    var clone = $(".slide").first().clone();
    $(".slider__container").append(clone.addClass("cloned"));

    const testimonials = new TimelineMax({ paused: true });
    testimonials.staggerFrom(
      ".slide",
      0.7,
      {
        x: "100%",
        autoAlpha: 1,
        className: "+=is-from",
        ease: new Ease(BezierEasing(0.48, 0, 0.12, 1)),
      },
      4
    );
    testimonials.staggerTo(
      ".slide:not(.cloned)",
      0.9,
      { scale: 0.75, autoAlpha: 0, className: "+=is-active" },
      4,
      4
    );

    this.Animation.testimonials = testimonials;

    tipad.call(this.ipadComplete.bind(this));
    tipad.play();

    testimonials.call(this.testimonialsComplete.bind(this));
    testimonials.play();

    TweenMax.to(this.gradient, 10, {
      x: "-50%",
      y: "-50%",
      rotation: 360,
      repeat: -1,
    });
  }

  ipadComplete() {
    this.Animation.ipad.play(0.7);
  }

  testimonialsComplete() {
    this.Animation.testimonials.play(0.7);
  }

  complete() {
    $("html").addClass("initialized");
    this.resize();
  }

  resize(e) {
    if (!e) {
      e = stage;
    }

    this.isMobile = e.w < 768;

    this.animate.each((i, el) => {
      const show = $(el);
      const showrect = show.offset();
      const showheight = show.height();
      const showwidth = show.width();
      const offset = show.data("offset") || 0;

      show.data("bottom", showrect.top + showheight);
      show.data("top", showrect.top + offset);
      show.data("left", showrect.left);
      show.data("width", showwidth);
      show.data("height", showheight);
    });

    this.parallax.each((i, el) => {
      const imgel = $(el);
      const rect = imgel.offset();
      const height = imgel.height();

      imgel.data("top", rect.top);
      imgel.data("height", height);
      imgel.data("image", $(".bg", imgel));
    });

    //2400 = 1
    var max = Math.max(e.w, e.h);

    var scale = this.isMobile ? e.w / 768 : e.w / 1440;
    var obj = this.isMobile
      ? { scale: scale, force3D: true, x: 0, y: 0 }
      : { scale: scale, force3D: true };
    TweenMax.set(this.calculator, { clearProps: "all" });
    TweenMax.set(this.calculator, obj);
    TweenMax.set(this.gradient, { clearProps: "all" });
    TweenMax.set(this.gradient, { width: 2 * max, height: 2 * max });

    var angle = this.isMobile
      ? this.getAngleDeg(40, stage.w)
      : this.getAngleDeg(200, stage.w);

    $(".bg").each((index, el) => {
      var sign = el.dataset.orientation || -1;
      TweenMax.set(el, { rotation: sign * angle, force3D: true });
    });

    this.render(e);
  }

  render(e) {
    this.animate.each((i, el) => {
      const show = $(el);
      const showindex = show.data("height");
      const showtoken = show.data("top");
      const showinview =
        e.scrolltop + e.h > showtoken && e.scrolltop < showtoken + showindex;
      const showloading = e.scrolltop <= showtoken - e.h;

      show.toggleClass("in-view", showinview);
      show.toggleClass("hide", showloading);

      if (show.hasClass("stairs")) {
        if (showloading) {
          this.Animation.share.seek(0);
          this.Animation.share.pause();
        } else {
          this.Animation.share.paused() ? this.Animation.share.restart() : null;
        }
      }

      if (show.hasClass("statuses")) {
        if (showloading) {
          this.Animation.spreadsheets.seek(0);
          this.Animation.spreadsheets.pause();
        } else {
          this.Animation.spreadsheets.paused()
            ? this.Animation.spreadsheets.restart()
            : null;
        }
      }

      if (show.hasClass("calculator")) {
        if (showloading) {
          this.Animation.calculator.seek(0);
          this.Animation.calculator.pause();
        } else {
          this.Animation.calculator.paused()
            ? this.Animation.calculator.restart()
            : null;
        }
      }
    });

    if (e.scrolltop > 200) {
      TweenMax.set(this.parallaxvideo, {
        y: -((e.scrolltop - 200) / 5),
        force3D: true,
      });
    } else {
      TweenMax.set(this.parallaxvideo, {
        y: 0,
        force3D: true,
      });
    }

    if (e.scrolltop > e.h + 100) {
      this.video.pause();
    } else {
      this.video.play();
    }
  }

  getAngleDeg(a, b) {
    var angleRad = Math.atan(a / b),
      angleDeg = (angleRad * 180) / Math.PI;

    return angleDeg;
  }

  destroy() {
    //console.log('destroy')
  }
}

module.exports = Homepage;
